// extracted by mini-css-extract-plugin
export var desc = "advantages-module--desc--3Uw7N";
export var head = "advantages-module--head--iGk2J";
export var img = "advantages-module--img--Ovnyv";
export var item = "advantages-module--item--eXFqV";
export var items = "advantages-module--items--gE02y";
export var root = "advantages-module--root---dtpV";
export var sup = "advantages-module--sup--2clkS";